// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DeviceEditStep_wrapper__6x3gL","field":"DeviceEditStep_field__2RFVc","text":"DeviceEditStep_text__3Gi0z"};